import { useHookstate } from "@hookstate/core";
import { MAP_GLOBAL_STATES } from "globalStore/globalStore";
import React from "react";
import PeoplePage from "./PeopleTab";
import GroupPage from "./GroupTab";
import VehiclePage from "./VehicleTab";

export const People = () => { 
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  if(window.innerWidth < 650){
    return <PeoplePage />;
  }else{
    switch (mapSideNavTabState.get()) {
      case "People":
        return <PeoplePage />;
      case "Groups":
        return <GroupPage />;
      case "Vehicles":
        return <VehiclePage />;
      default:
        return;
    }
  }
};
